import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import buildLinkObj, { getRel } from '@repo/ui/src/functions/build-link';
import Image from 'next/image';
import { memo } from 'react';

interface AmbassadorMeta {
  deliveryKey: string;
  [key: string]: any;
}

interface AmbassadorItem {
  name: string;
  title?: string;
  avatar: any;
  city?: string;
  stateProvince?: string;
  country?: string;
  _meta?: AmbassadorMeta;
}

interface AmbassadorsGridItemProps {
  item: AmbassadorItem;
}

const AmbassadorsGridItem = ({ item }: AmbassadorsGridItemProps) => {
  const { name, title, avatar, city, stateProvince, country, _meta } = item || {};
  const imgUrl = buildImageSrc(avatar, 300, 4, 5);
  const linkObj = buildLinkObj({ link: _meta?.deliveryKey });

  return (
    <div className="h-full p-3 lg:p-6">
      <a rel={getRel(linkObj)} href={linkObj.href} className="flex flex-col h-full">
        <div className="relative w-full aspect-[4/5] flex-shrink-0">
          <Image
            src={imgUrl}
            alt="Ambassador Profile"
            fill
            sizes="(max-width: 768px) 100vw, 300px"
            className="object-cover"
          />
        </div>
        <div className="flex-1 p-4 border border-neutral-200 border-t-0 flex flex-col justify-start">
          <h6 className="font-bold text-left mb-4">{name}</h6>
          {title && <p className="text-left mb-2 text-brand-500 tra-text-web-sub-2">{title}</p>}
          {city && stateProvince && (
            <p className="mb-0 text-warm-500">
              {city}
              {city && stateProvince ? <>,&nbsp;</> : null}
              {stateProvince}
              {(city || stateProvince) && country ? <>,&nbsp;</> : null}
              {country}
            </p>
          )}
        </div>
      </a>
    </div>
  );
};

export default memo(AmbassadorsGridItem);
